<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div class="col-span-12 lg:col-span-10">
            <org-unit-historical-invoices :teamId="props.teamId" :orgUnitId="props.orgUnitId" />
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitHistoricalInvoices from '~/components/settings/billing/OrgUnitHistoricalInvoices.vue';
import OrgUnitDetails from '../form/OrgUnitDetails.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});
</script>
